export const checkBitPosition = (permission = 0, position = 0) => {
	return permission & (1 << position);
};
